<template>
  <div>
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form :inline="true" size="mini" label-width="80px" :model="formData" ref="searchForm">
            <el-form-item label="品类" prop="style">
              <el-input v-model.trim="formData.style" placeholder="请输入品类" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="产品描述" prop="productDesc">
              <el-input v-model.trim="formData.productDesc" placeholder="请输入产品描述" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="产品型号" prop="productType">
              <el-input v-model.trim="formData.productType" placeholder="请输入产品型号" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="产品编码" prop="productCode">
              <el-input v-model.trim="formData.productCode" placeholder="请输入产品编码" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="打样型号" prop="demoType">
              <el-input v-model.trim="formData.demoType" placeholder="请输入打样型号" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
            <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
          </template>
        </search-box>
      </template>

      <table-panel ref="tablePanel">
        <template v-slot:header-right>
          <el-button type="primary" size="mini" @click="add">新增</el-button>
          <!-- <el-button type="warning" size="small" @click="deleteSelection">删除</el-button>
          <el-button type="primary" size="small" @click="importProduct">导入</el-button> -->
          <el-button type="primary" size="mini" @click="onExport">导出</el-button>
          <el-button type="warning" size="mini" @click="selectConfirm" v-if="pageType == 1">确定</el-button>
          <el-button slot="reference" type="primary" size="mini" @click="tableVisible = true">表格设置</el-button>
        </template>
        <el-table
          stripe
          border
          ref="tableRef"
          :header-cell-style="{backgroundColor: '#F4F8FB'}"
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
          @selection-change="onSelectChange"
          v-if="tableReload"
          v-loading="loading"
        >
          <el-table-column type="selection" v-if="pageType == 1"></el-table-column>
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="item.width"
            :sortable="item.sortable ? 'custom' : false"
            :align="item.align"
            :fixed="item.fixed"
            show-overflow-tooltip
            v-for="item in columnData"
            :key="item.prop"
          >
            <template slot-scope="scope">
              <template v-if="item.label == '图片'">
                <template v-if="showDetailBtn(scope.row)">
                  <el-link :underline="false" type="primary" @click="showDialog(scope.row, 0)">查看</el-link>
                </template>
              </template>
              <template v-else>
                {{scope.row[item.prop]}}
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-link :underline="false" type="primary" @click="edit(scope.row)">编辑</el-link>&nbsp;
              <el-link :underline="false" type="danger" @click="onDelete(scope.row)" v-if="scope.row.dataSource == '自建'">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="paginationOpt.pageNum"
              :page-sizes="paginationOpt.pageSizes"
              :page-size="paginationOpt.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              background
              :total="paginationOpt.total"
            ></el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <!-- 新增、修改 -->
    <review-product-add
      v-if="addDialogVisible"
      :visible.sync="addDialogVisible"
      :rowData="editData"
      :actionType="actionType"
      @success="init"
    />
    <!-- 视频、图片查看 -->
    <pic-video v-model="picVideoVisible" :data="rowData" :detailType="viewType" v-if="picVideoVisible"></pic-video>
    <!-- 导入导出 -->
    <import-export ref="importExport" @onsuccess="init"></import-export>
    <!-- 自定义表格 -->
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>
  </div>
</template>

<script>
  import addeditMixin from './add&edit.mixin'
  import delMixin from './del.mixin'
  import picVideoMxin from './pic&video.mixin'
  import importExportMxin from './import&export.mixin'
  import customColumn from './customProps.mixin'
  import pagePathMixin from '@/utils/page-path-mixin'
  import tableMixin from '@/utils/tableMixin'
  import { mapGetters } from 'vuex'
  export default {
    name: "skuList",
    mixins: [addeditMixin, delMixin, picVideoMxin, importExportMxin, customColumn, pagePathMixin, tableMixin],
    components: {},
    data() {
      return {
        loading: false,
        tableReload: true,
        formData: {
          style: '',
          productDesc: '',
          productType: '',
          productCode: '',
          demoType: ''
        },
        tableData: [],
        paginationOpt: {
          pageSizes: [30, 60, 90],
          pageSize: 30,
          pageNum: 1,
          total: 0
        }
      }
    },
    computed: {
      pageType() {
        return this.$route.params.type;
      },
      ...mapGetters({
        visitedViews: 'visitedViews'
      })
    },
    watch: {
      '$route' (to, from) {
        // 动态设置tagView标签title
        let data = Array.from(this.visitedViews);
        let title;
        data.forEach(item=>{
          if(item.path === '/newProduct/sku-list/1') {
            item.title = '已评审产品';
          }
          if(item.path === '/newProduct/sku-list/2') {
            item.title = '已评审产品汇总表';
          }
        })
        this.$store.commit('tagsView/MODIFY_VISITED_VIEW', data);
        if(this.$route.path === '/newProduct/sku-list/1') {
          title = '已评审产品'
        }else{
          title = '已评审产品汇总表'
        }
        document.title = title;
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      onSearch() {
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      reset() {
        this.$refs.searchForm.resetFields();
        this.formData = {
          style: '',
          productDesc: '',
          productType: '',
          productCode: '',
          demoType: ''
        };
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      init() {
        this.loading = true;
        let formData = {
          pageSize: this.paginationOpt.pageSize,
          pageNum: this.paginationOpt.pageNum,
          filterData: {
            ...this.formData
          }
        };
        this.$q.newProduct.reviewProducts({data: formData})
        .then(res=>{
          this.tableData = res.data.records;
          this.paginationOpt['total'] = res.data.total;
        })
        .finally(_=>{
          this.loading = false;
        })
      },
      // 分页器 pagesize
      handleSizeChange(val) {
        this.paginationOpt.pageSize = val;
        this.paginationOpt.pageNum = 1;
        this.init();
      },
      // 分页器 pageNum
      handleCurrentChange(val) {
        this.paginationOpt.pageNum = val;
        this.init();
      }
    }
  }
</script>
<style lang="stylus" scoped></style>